import { Subject } from 'rxjs';
function handleClose(containerElement, closeFunctions, closeListeners) {
    if (closeListeners === void 0) { closeListeners = ['click', 'touchend', 'keyup']; }
    var closeControl = closeFunctions.closeControl;
    var listenForClose = closeFunctions.listenForClose;
    // Setup click to dismiss
    var closeHandler = function (event) {
        if (event) {
            event.preventDefault();
        }
        closeControl();
    };
    closeListeners.forEach(function (eventName) {
        return document.addEventListener(eventName, closeHandler);
    });
    listenForClose().subscribe(function () {
        closeListeners.forEach(function (eventName) {
            return document.removeEventListener(eventName, closeHandler);
        });
        containerElement.remove();
    });
}
export function setupCloseHandlers(containerElement, closeListeners) {
    // Set up close handlers
    var closeSubject = new Subject();
    var closeControl = function () {
        closeSubject.next();
        closeSubject.complete();
    };
    var listenForClose = function () {
        return closeSubject.asObservable();
    };
    var closeFunctions = {
        closeControl: closeControl,
        listenForClose: listenForClose,
    };
    handleClose(containerElement, closeFunctions, closeListeners);
    return closeFunctions;
}
//# sourceMappingURL=setupCloseHandlers.js.map